var map = {
	"./email.png": 17,
	"./hnc.jpg": 50,
	"./hnc_banner.jpg": 51,
	"./logo_facebook.png": 18,
	"./logo_linkedin.png": 19,
	"./logo_twitter.png": 20,
	"./spinneret_arrival.jpg": 52,
	"./straw_prototype.jpg": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;